// extracted by mini-css-extract-plugin
export default {"loading":"loadingDots_loading__TU-6k","spacer":"loadingDots_spacer__C4f+S","blink":"loadingDots_blink__xoLaN","loading2":"loadingDots_loading2__KhYBJ"};